import { Tooltip } from "@mui/material";
import { useId } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import BadgeEstados from "../../../components/BadgeEstado";
import { validarCambioDeDatos } from "../../../utils/validacionesEventosActas";

const CambiosEvento = ({ params }) => {
  const randomId = useId();

  return (
    <div className="d-flex gap-2">
      {/* Acta Cargada por Empresa */}
      {!params.row?.properties.old &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.estado_id === 1 && (
          <div className="d-flex gap-1">
            <span className="m-0 text-primary fw-bold">•</span>
            <span className="m-0 text-primary fw-bold">Acta cargada por empresa</span>
          </div>
        )}

      {/* Modelo eliminado */}
      {params.row?.event &&
        params.row?.event === "deleted" &&
        params.row?.description &&
        params.row?.description === "Este modelo ha sido eliminado" && (
          <div className="d-flex gap-1">
            <span className="m-0 text-danger fw-bold">•</span>
            <span className="m-0 text-danger fw-bold">
              {params.row?.description}.{" "}
              {params.row?.properties?.old?.acta_id ??
                `Acta ID: ${params.row?.properties?.old?.acta_id}`}
            </span>
          </div>
        )}

      {/*  Acta Digital Generada */}
      {params.row?.event?.attributes &&
        params.row?.properties?.attributes?.tipo_acta_generada === "DIGITAL" &&
        params.row?.properties?.attributes?.fecha_emision_digital && (
          <div className="d-flex gap-1">
            <span className="m-0 text-primary fw-bold">•</span>
            <span className="m-0 text-primary fw-bold">Acta Digital Generada</span>
          </div>
        )}

      {/* Motivo Anulacion */}
      {params.row?.subject_type && params.row?.subject_type === "App\\Models\\MotivoAnulacion" && (
        <>
          <div className="d-flex gap-1">
            <span className="m-0 text-primary fw-bold">•</span>
            <div className="d-flex gap-2">
              <span className="m-0 text-primary fw-bold text-decoration-underline">Motivo:</span>
              <span className="m-0 text-primary fw-bold">{params.row?.subject?.motivo}</span>
            </div>
          </div>
        </>
      )}

      {/* Notificador Asignado */}
      {params.row?.subject?.persona && (
        <>
          <div className="d-flex gap-1">
            <span className="m-0 text-primary fw-bold">•</span>
            <div className="d-flex gap-2">
              <span className="m-0 text-primary fw-bold text-decoration-underline">
                Notificador:
              </span>
              <Tooltip
                title={`ID Usuario: ${params.row?.subject?.persona?.usuarioID}`}
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#1134C9",
                      color: "#fff",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#1134C9",
                    },
                  },
                }}
                arrow
              >
                <span className="m-0 text-primary fw-bold">
                  {params.row?.subject?.persona?.correoElectronico}
                </span>
              </Tooltip>
            </div>
          </div>
        </>
      )}

      {/* Cambio de Estado */}
      {params.row?.properties?.old && params.row?.properties?.old?.estado_id && (
        <div className="d-flex gap-1">
          <span className="m-0 text-primary fw-bold">•</span>
          <span>
            <BadgeEstados estado_id={params.row?.properties?.old?.estado_id} />
          </span>
        </div>
      )}
      {params.row?.properties?.old &&
        params.row?.properties?.old?.estado_id &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.estado_id && (
          <div className="d-flex gap-2">
            {params.row?.properties?.old?.estado_id && (
              <span className="m-0 text-primary fw-bold">{">"}</span>
            )}
            <OverlayTrigger
              trigger={["hover", "focus"]}
              key={randomId}
              placement="right-start"
              overlay={
                <Popover id={`popover-positioned-top-${randomId}`}>
                  {/* Cabecera (titulo) popover */}
                  {params.row?.properties?.old?.estado_id === 3 &&
                    params.row?.properties?.attributes?.estado_id === 4 &&
                    params.row?.properties?.attributes?.observacion_notificador && (
                      <Popover.Header as="h3">Observación Notificador</Popover.Header>
                    )}
                  {/* Observacion Notificador */}
                  {params.row?.properties?.old?.estado_id === 8 &&
                    params.row?.properties?.attributes?.estado_id === 6 && (
                      <Popover.Header as="h3">Observación</Popover.Header>
                    )}
                  {params.row?.properties?.attributes?.estado_id === 9 &&
                    params.row?.properties?.attributes?.observacion_notificador && (
                      <Popover.Header as="h3">Observación Notificador</Popover.Header>
                    )}

                  {/* Cuerpo popover  */}
                  {params.row?.properties?.old?.estado_id === 3 &&
                    params.row?.properties?.attributes?.estado_id === 4 &&
                    params.row?.properties?.attributes?.observacion_notificador && (
                      <Popover.Body>
                        <strong>
                          {params.row?.properties?.attributes?.observacion_notificador}
                        </strong>
                      </Popover.Body>
                    )}
                  {params.row?.properties?.old?.estado_id === 8 &&
                    params.row?.properties?.attributes?.estado_id === 6 && (
                      <Popover.Body>
                        <div>
                          <span className="text-primary fw-bold">
                            Fecha Notificación:{" "}
                            <span className="text-dark fw-medium">
                              {" "}
                              {new Date(
                                params.row?.properties?.attributes?.fecha_notificacion
                              ).toLocaleDateString("es-AR")}
                            </span>
                          </span>
                        </div>
                        <div>
                          <span className="text-primary fw-bold">
                            Fecha Vencimiento Prejudicial:{" "}
                            <span className="text-dark fw-medium">
                              {" "}
                              {new Date(
                                params.row?.properties?.attributes?.fecha_vto_prejudicial
                              ).toLocaleDateString("es-AR")}
                            </span>
                          </span>
                        </div>
                      </Popover.Body>
                    )}
                  {params.row?.properties?.attributes?.estado_id === 9 &&
                    params.row?.properties?.attributes?.observacion_notificador && (
                      <Popover.Body>
                        <strong>
                          {params.row?.properties?.attributes?.observacion_notificador}
                        </strong>
                      </Popover.Body>
                    )}
                </Popover>
              }
            >
              <span>
                <BadgeEstados estado_id={params.row?.properties?.attributes?.estado_id} />
              </span>
            </OverlayTrigger>
          </div>
        )}

      {/* Cambio de Datos */}
      {params.row?.properties?.old &&
        !params.row?.properties?.old?.estado_id &&
        params.row?.properties?.attributes &&
        !params.row?.properties?.attributes?.estado_id &&
        validarCambioDeDatos(params.row.properties?.old, params.row.properties?.attributes) && (
          <>
            <div className="d-flex gap-1">
              <span className="m-0 text-primary fw-bold">•</span>
              <span className="badge text-bg-light">CAMBIO DE DATOS</span>
            </div>
          </>
        )}

      {/* Verificación y asignación Pago Voluntario */}
      {params.row?.properties?.old &&
        !params.row?.properties?.old?.is_voluntario &&
        !params.row?.properties?.old?.pago_voluntario_id &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.is_voluntario &&
        params.row?.properties?.attributes?.pago_voluntario_id && (
          <>
            <div className="d-flex gap-2">
              <span className="m-0 text-primary fw-bold">•</span>
              <span className="m-0 text-primary fw-bold">
                Verificación y asignación Pago Voluntario
              </span>
            </div>
          </>
        )}

      {/* Asignacion de artículo infracción */}
      {params.row?.properties?.old &&
        !params.row?.properties?.old?.articulos &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.articulos && (
          <>
            <div className="d-flex gap-2">
              <span className="m-0 text-primary fw-bold">•</span>
              <span className="m-0 text-primary fw-bold">Asignación de artículo</span>
            </div>
          </>
        )}

      {/* Inserción de datos en columnas */}
      {params.row?.properties?.old &&
        !params.row?.properties?.old?.estado_id &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.estado_id === 1 && (
          <>
            <div className="d-flex gap-2">
              <span className="m-0 text-primary fw-bold">•</span>
              <span className="m-0 text-primary fw-bold">Inserción de datos en columnas</span>
            </div>
          </>
        )}

      {/* Fecha emision fisica */}
      {params.row?.properties?.old &&
        !params.row?.properties?.old?.fecha_emision_fisica &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.fecha_emision_fisica && (
          <div className="d-flex gap-2">
            <span className="m-0 text-primary fw-bold">•</span>
            <span className="m-0 text-primary fw-bold">Se generó Acta Física</span>
          </div>
        )}

      {/* Fecha emision digital */}
      {params.row?.properties?.old &&
        !params.row?.properties?.old?.fecha_emision_digital &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.fecha_emision_digital && (
          <div className="d-flex gap-2">
            <span className="m-0 text-primary fw-bold">•</span>
            <span className="m-0 text-primary fw-bold">Se generó Acta Digital</span>
          </div>
        )}

      {/* Fecha vencimiento prejudicial */}
      {params.row?.properties?.old &&
        !params.row?.properties?.old?.fecha_vto_prejudicial &&
        params.row?.properties?.attributes &&
        params.row?.properties?.attributes?.fecha_vto_prejudicial && (
          <div className="d-flex gap-2">
            <span className="m-0 text-primary fw-bold">•</span>
            <span className="m-0 text-primary fw-bold">
              Fecha Vto. Prejudicial:{" "}
              {new Date(
                params.row?.properties?.attributes?.fecha_vto_prejudicial
              ).toLocaleDateString("es-AR")}
            </span>
          </div>
        )}
    </div>
  );
};

export default CambiosEvento;
